import 'core-js';
import 'whatwg-fetch';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import router from './router/index';
import store from './vuex/store';
import App from './App.vue';
import psHttp from '@patsnap/common-ps-http';
import 'library-@/assets/styles/reset.scss';
import { get, merge, set } from 'lodash';
import setWebsitFont from 'library-@/utils/configure-website-font';

import { prepareTokenBase, updateTokenBaseRequestHeaders } from 'library-@/token-base/for-new-projects';
import { PRESETS_TOKEN_BASE_HISTORY } from 'library-@/token-base/presets';
import { initTransformCodeInterceptor } from 'library-@/apis/interceptors/transform_code.interceptor';
import { HeaderService } from '@patsnap-utils/biz';
import defer from 'library-@/startup/defer';
import { pageInit } from '@/api/history';

import en from 'element-ui/lib/locale/lang/en';
import jp from 'element-ui/lib/locale/lang/ja';
import cn from 'element-ui/lib/locale/lang/zh-CN';
import tw from 'element-ui/lib/locale/lang/zh-TW';
import { initSaveToWorkspaceI18n, setDefaultPatsnapZIndex } from 'library-@/config/save-to-workspace-config';
import elementLocale from 'element-ui/lib/locale';
import { getLangValue, getClientUUID } from './utils/langUtils';
import { ACCOUNT_SERVICE_URI } from 'library-@/config/apiConfig';
import setTitle from './utils/setTitle';
import { getServiceTimeStamp } from 'library-@/apis/core_basic_api/analytics';

setDefaultPatsnapZIndex();

async function langGetter(lang = 'en') {
    let results = {};
    if (lang === 'cn') {
        results = await Promise.all([
            import(`CommonMessages/common-product/cn.json`),
            import(`CommonMessages/analytics-history/cn.json`),
            import(`CommonMessages/common-errorcode/cn.json`),
            import(`CommonMessages/analytics-export/cn.json`),
            import(`CommonMessages/analytics-snap-business/cn.json`),
        ]);
    } else if (lang === 'tw') {
        results = await Promise.all([
            import(`CommonMessages/common-product/tw.json`),
            import(`CommonMessages/analytics-history/tw.json`),
            import(`CommonMessages/common-errorcode/tw.json`),
            import(`CommonMessages/analytics-export/tw.json`),
            import(`CommonMessages/analytics-snap-business/tw.json`),
        ]);
    } else if (lang === 'en') {
        results = await Promise.all([
            import(`CommonMessages/common-product/en.json`),
            import(`CommonMessages/analytics-history/en.json`),
            import(`CommonMessages/common-errorcode/en.json`),
            import(`CommonMessages/analytics-export/en.json`),
            import(`CommonMessages/analytics-snap-business/en.json`),
        ]);
    } else if (lang === 'jp') {
        results = await Promise.all([
            import(`CommonMessages/common-product/jp.json`),
            import(`CommonMessages/analytics-history/jp.json`),
            import(`CommonMessages/common-errorcode/jp.json`),
            import(`CommonMessages/analytics-export/jp.json`),
            import(`CommonMessages/analytics-snap-business/jp.json`),
        ]);
    }
    const data = results.reduce((obj, data) => merge(obj, data), {});
    return { [lang]: data };
}

async function loadingCallback(headerService, history_permission, timestamp) {
    const accountInfo = get(headerService, 'account._info', {});
    let zPREFACE = {
        accountInfo,
        history_permission,
        timestamp
    };
    set(window, 'zPREFACE', zPREFACE);
    set(window, 'zPREFACE.trackData.source', 'History');
    const siteLang = await getLangValue();
    set(window, 'zPREFACE.lang', siteLang);
    setWebsitFont(siteLang);
    const clientUUID = await getClientUUID();
    updateTokenBaseRequestHeaders({
        'X-Site-Lang': siteLang,
        'X-Device-ID': clientUUID
    });


    Vue.use(VueI18n);


    // debug mode
    const isDebug = process.env.NODE_ENV !== 'production';
    Vue.config.debug = isDebug;
    Vue.config.devtools = isDebug;

    const locales = await langGetter(siteLang);
    const elementUi = { en, jp, cn, tw };
    const i18n = new VueI18n({
        locale: siteLang,
        messages: merge({}, elementUi, locales)
    });
    elementLocale.i18n((key, value) => i18n.t(key, value));

    setTitle({ locale: i18n.locale, isWhiteLabel: headerService.whiteLabel });

    initSaveToWorkspaceI18n({ i18n, lang: siteLang || 'en' });
    initTransformCodeInterceptor(i18n);

    Vue.mixin({
        data() {
            return {
                headerService,
            };
        },
    });

    Vue.config.lang = siteLang;
    /* eslint-disable no-new */
    new Vue({
        el: '#app',
        template: '<div  class="history-module"><app></app></div>',
        router,
        i18n,
        store,
        components: {
            App
        }
    });
    store.dispatch('initLegalConfig')
    window.hidePageLoading && window.hidePageLoading();
    defer(Vue, 'History', headerService.account, { sentry: true }, siteLang);
}

prepareTokenBase({
    ...PRESETS_TOKEN_BASE_HISTORY,
}).then(() => {
    const headerService = new HeaderService();
    Promise.all([
        headerService.sync({
            http: psHttp,
            uri: ACCOUNT_SERVICE_URI
        }),
        /* history init */
        pageInit(),
    ]).then(async ([, initData]) => {
        /* 获取服务端时间戳 */
        let timestamp;
        try {
            timestamp = await getServiceTimeStamp();
        } catch (err) {
            timestamp = new Date().getTime();
            console.log(err)
        }
        loadingCallback(headerService, get(initData, 'data.data.history_permission'), timestamp);
    });
});
